import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { startCase } from 'lodash';
import TextEditor from '@/components/TextEditor.vue';
let CharacterSheetDescription = class CharacterSheetDescription extends Vue {
    constructor() {
        super(...arguments);
        this.startCase = startCase;
        this.editing = '';
    }
};
__decorate([
    Prop(String)
], CharacterSheetDescription.prototype, "alignment", void 0);
__decorate([
    Prop(String)
], CharacterSheetDescription.prototype, "background", void 0);
__decorate([
    Prop(Array)
], CharacterSheetDescription.prototype, "proficiencies", void 0);
__decorate([
    Prop(Array)
], CharacterSheetDescription.prototype, "languages", void 0);
__decorate([
    Prop(Object)
], CharacterSheetDescription.prototype, "characteristics", void 0);
CharacterSheetDescription = __decorate([
    Component({
        components: {
            TextEditor
        }
    })
], CharacterSheetDescription);
export default CharacterSheetDescription;
